export default {
  FETCH_STUDENT_GRAPH_INTERACTIONS: 'FETCH_STUDENT_GRAPH_INTERACTIONS',
  GET_STUDENT_ENGAGEMENT: 'GET_STUDENT_ENGAGEMENT',
  GET_STUDENT_CUMULATIVE_ENGAGEMENT: 'GET_STUDENT_CUMULATIVE_ENGAGEMENT',
  GET_STUDENT_EXEMPTIONS: 'GET_STUDENT_EXEMPTIONS',
  GET_STUDENT_COURSE_TOP: 'GET_STUDENT_COURSE_TOP',
  GET_STUDENT_COURSE_AVERAGE: 'GET_STUDENT_COURSE_AVERAGE',
  GET_STUDENT_CUMULATIVE_COURSE_TOP: 'GET_STUDENT_CUMULATIVE_COURSE_TOP',
  GET_STUDENT_CUMULATIVE_COURSE_AVERAGE: 'GET_STUDENT_CUMULATIVE_COURSE_AVERAGE'
}



// WEBPACK FOOTER //
// ./src/store/graphRequestTypes.js